var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C6.37259 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1ZM13 23.44C7.23415 23.44 2.56 18.7659 2.56 13C2.56 7.23415 7.23415 2.56 13 2.56C18.7659 2.56 23.44 7.23415 23.44 13C23.44 18.7659 18.7659 23.44 13 23.44Z",
    stroke: "#EEEBF6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12506 3.16459C7.92715 1.90494 10.0363 1.16749 12.2205 1.02534C12.6504 0.99736 13 1.34922 13 1.78V1.78C13 2.21078 12.6503 2.55697 12.2207 2.58912C10.3565 2.72864 8.55878 3.36675 7.01881 4.4432C5.26515 5.669 3.93047 7.40401 3.19542 9.41339C2.46037 11.4228 2.36045 13.6095 2.90919 15.6775C3.39106 17.4936 4.35272 19.1411 5.68682 20.4506C5.99425 20.7523 6.03803 21.2425 5.76006 21.5716V21.5716C5.48209 21.9007 4.98795 21.9439 4.6776 21.6451C3.10073 20.1271 1.96525 18.2027 1.40137 16.0776C0.770634 13.7005 0.885483 11.1871 1.73037 8.87746C2.57525 6.56783 4.10937 4.57356 6.12506 3.16459Z",
    stroke: "url(#paint0_linear_7112_38231)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7112_38231",
    x1: 21.7826,
    y1: 4.56522,
    x2: 4.08696,
    y2: 20.9565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#441A98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D62B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncSpinner);
export default __webpack_public_path__ + "static/media/sync_spinner.4262f633451a9fc5ba2167b899bead17.svg";
export { ForwardRef as ReactComponent };